/**
 * Les TEXTES SUPPORTS des variantes de compréhension de l'écrit, par id (11/10/2026).
 *
 * Une variante ne range que la référence de son texte (utils/supportLecture.js) ; le livre du quiz et la
 * carte du prof retrouvent ici le texte complet, écrit dans le module de son test. Un texte qui a disparu
 * du code s'annonce comme introuvable : jamais le texte de septembre à la place, en silence.
 */
import { referenceSupportLecture } from '../../utils/supportLecture';
import { SUPPORT as arachne } from './2026/francais/6e/arachne';
import { SUPPORT as sommeil } from './2026/francais/6e/sommeil';
import { SUPPORT as petitChose } from './2026/francais/4e/petit_chose';
import { SUPPORT as volcans } from './2026/francais/4e/volcans';
// Les textes des formes parallèles (11/10/2026) : leurs questions, créées en base, les référencent aussi
import { SUPPORT_FEES, SUPPORT_ABEILLES } from './formesParalleles/positionnement6e';
import { SUPPORT_COPISTE } from './formesParalleles/copiste4e';
import { SUPPORT_VOLCANS } from './formesParalleles/volcans4e';

export const SUPPORTS_LECTURE = new Map(
    [arachne, sommeil, petitChose, volcans, SUPPORT_FEES, SUPPORT_ABEILLES, SUPPORT_COPISTE, SUPPORT_VOLCANS]
        .map((support) => [support.id, support]),
);

// Le genre de chaque texte (12/10/2026) : le livre lit un texte littéraire en police à empattements, un document
// dans la police habituelle
const DOCUMENTAIRES = new Set([sommeil.id, volcans.id, SUPPORT_ABEILLES.id, SUPPORT_VOLCANS.id]);

/** 'documentaire' ou 'litteraire' pour un texte connu (son id), sinon null. */
export const genreDuSupport = (id) => {
    if (!SUPPORTS_LECTURE.has(id)) return null;
    return DOCUMENTAIRES.has(id) ? 'documentaire' : 'litteraire';
};

const introuvable = (ref) => ({
    id: ref.id,
    titre: ref.titre || 'Texte introuvable',
    pages: [{ page: 1, title: 'Texte introuvable', content: "Le texte de cette variante n'est plus disponible." }],
});

/** Le texte complet d'une question (une variante de compréhension), ou null : elle n'a pas de texte propre. */
export const supportDeQuestion = (question) => {
    const ref = referenceSupportLecture(question);
    if (!ref) return null;
    if (Array.isArray(ref.pages) && ref.pages.length > 0) return ref;
    return SUPPORTS_LECTURE.get(ref.id) || introuvable(ref);
};
